import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { UtilsService } from 'src/app/services/utils.service';
import { Data, EsoService, Product } from '../../eso/eso.service';
import { CapacityService } from '../capacity.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';

enum CounterGroups {
	PAGE_LOAD = 1
}

@Component({
    selector: 'app-capacity-deep-dive',
    templateUrl: './capacity-deep-dive.component.html',
    styleUrls: ['./capacity-deep-dive.component.scss'],
    standalone: false
})
export class CapacityDeepDiveComponent implements OnInit {
	private readonly _capacityCaptions = [
		{ columnName: 'CapacityGroup2', caption: 'CapacityGroup2' },
		{ columnName: 'CapacityClientCode', caption: 'CapacityClientCode' },
		{ columnName: 'CapacityGroup1', caption: 'CapacityGroup1' },
		{ columnName: 'ProcessUnitsPerHour', caption: 'ProcessUnitsPerHour' },
		{ columnName: 'ChangeOverTimeHour', caption: 'ChangeOverTimeHour' }
	];

	public levelsDropdownOptions: string[] = ["All", "0", "1", "2", "3"];
	public sourcingTreeListColumns: { columnName: string; caption: string }[] = [];
	public sourcingTreeListData: any[] = [];

	SecondHeaderName: string = "";
	autoCompleteAllProducts: string[] = [];
	autoCompleteProductDataSource: string[] = [];
	allProducts: Data[];
	productsDataSource: any = {};
	selectedProduct: Data;
	selectedProductCode: string;
	product: Product;
	focusedRowKey = 0;

	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

	public productCapacityInfoGridDataColumns: { columnName: string; caption: string }[] = [];
	public productCapacityInfoGridData: any[] = [];

	// <General>
	private readonly _componentTitle = "Capacity Deep Dive";
	// private readonly _QueryParamName = "NONE";
	private readonly _productIdQueryParamName = "productId";
	// </General>

	constructor(
		private capacityService: CapacityService,
		private route: ActivatedRoute,
		private esoService: EsoService,
		private location: Location,
		private titleService: Title,
		private tableParamService: TableParameterService) {

	}

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);

		this.getAutocompleteList();

		this.initProductByDefaultValue();

		this.route.queryParamMap.subscribe(
			(queryParams) => {
				let productId = queryParams.get(this._productIdQueryParamName);
				if (productId != null) {
					this.getProductById(productId).subscribe(
						(productData) => {

							this.getCapacityTable(productId);
							this.getProductsData(productData);
						}
					);
				} else {
					this.getProductsData();
				}
			}
		);
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-capacity-deep', JSON.stringify(this.dataGrid.instance.state()));
	}

	public treeListToggleValue: boolean = false;
	public onTreeListToggleClicked(event: boolean) {
		console.log("onTreeListToggleClicked - event:", event);

		this.treeListToggleValue = event;
	}

	public treeCapacityToggleValue: boolean = true;
	public onTreeToggleClicked(event: boolean) {
		console.log("ontreeCapacityToggleClicked - event:", event);

		this.treeCapacityToggleValue = event;
	}

	public getCapacityTable(productId: string) {
		this.capacityService.getCapacityInfoByProduct(
			productId,
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {


					this.productCapacityInfoGridDataColumns = response.columns;
					this.productCapacityInfoGridData = response.data;
				}
			}
		);
	}

	public chooseProduct(code: string) {
		console.log("chooseProduct - code:", code);

		if (code) {
			const product = this.allProducts.find((product) => product.code === code);

			if (product) {
				this.focusedRowKey = product.index;

				this.getProductData([{ code: code }]);

				const url = `capacity/deep-dive?productId=${UtilsService.getURLHelper(code)}`;
				this.location.replaceState(url);
			}
		}
	}

	onAutocompleteItemClick(event) {
		this.chooseProduct(this.selectedProductCode);
		this.loadTreeListData();
		this.getCapacityTable(this.selectedProductCode);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	anyScopeTableActiveFilters = false;
	changeScopeTableActiveFiltersStatus() {
		if (this.anyScopeTableActiveFilters) {
			this.anyScopeTableActiveFilters = !this.anyScopeTableActiveFilters;
			this.dataGrid.instance.clearFilter();
		}
	}

	tableHeight = 500;
	switchTableHeight() {
		this.tableHeight = this.tableParamService.changeTableHeigh(this.tableHeight);
	}

	onToolbarPreparing(e: any) {
		e.toolbarOptions.items.unshift({
			location: "before",
			template: "columnMode",
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		});
	}

	compactMode = false;
	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;

		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	private getProductById(productId: string): Observable<Data | undefined> {
		if (!productId) {
			return of(undefined);
		}

		return this.esoService.getNetworkProduct(
			{
				productName: productId,
			}
		).pipe(
			map<Product, Data>((res) => {
				const product = res[0];
				if (!product) {
					return undefined;
				}

				if (res[0]?.secondHeaderName != null) {
					this.SecondHeaderName = res.secondHeaderName;
				}

				return {
					index: -1,
					code: productId,
					esoObjectGroup2: product.esoObjectGroup2,
					esoObjectGroup3: product.esoObjectGroup3,
					esoObjectGroup4: product.esoObjectGroup4,
					esoObjectGroup5: product.esoObjectGroup5,
					esoObjectId: product.productSuID,
					isAutoSimulated: false,
					severity: 0,
					userMsg: "",
				};
			})
		);
	}

	private loadTreeListData() {


		this.capacityService.getCapacityDeepDiveTreeListData(
			this.selectedProduct.esoObjectId,
			{
				showLoadingIndicator: true
			}
		).subscribe(
			{
				next: (response) => {
					this.sourcingTreeListColumns = response.columns;
					this.sourcingTreeListColumns.concat(this._capacityCaptions);

					// Clear array and add selected object.
					this.sourcingTreeListData = [{ ProductId: this.selectedProduct.code, InputEsoObjectId: this.selectedProduct.esoObjectId }];

					for (let a = 0; a < response.data.length; a++) {
						const element = response.data[a];

						this.sourcingTreeListData.push(element);
					}

					for (let i = 0; i < this.sourcingTreeListData.length; i++) {
						this.capacityService.getCapacityInfoByProduct(this.sourcingTreeListData[i].ProductId).subscribe(
							(response) => {
								this.sourcingTreeListData[i].capacityTable = response.data;
							}
						);
					}
				}
			}
		);
	}

	getAutocompleteList() {
		this.capacityService.getDeepDiveAutocompleteList().subscribe(res => {
			this.autoCompleteProductDataSource = res;
		});
	}

	private initProductByDefaultValue() {
		const initProduct = new Product();
		initProduct.cogsPerBatch = null;
		initProduct.cogsPerUnit = 0;
		initProduct.unplannedProdCost = 0;
		initProduct.unitsPerPallet = 0;
		initProduct.opexPerPalletPerPeriod = 0;
		initProduct.grossProfitPerUnit = 0;
		initProduct.calculationRatio = 0;
		initProduct.leadTimePeriods = 0;
		initProduct.lifeCyclePeriods = 0;
		initProduct.stockOutPenaltyPerUnit = 0;
		this.product = initProduct;
	}

	getProductData(item?: any[]) {
		if (item && typeof item[0] === "number") {
			this.selectedProduct = this.allProducts.find(
				(items) => items.index === item[0]
			);
		}
		if (item && typeof item[0] !== "number") {
			this.selectedProduct = this.allProducts.find(
				(items) => items.code === item[0].code
			);
		}

		this.esoService.getNetworkProduct(
			{
				productName: this.selectedProduct.code,
			},
			{
				showLoadingIndicator: true,
			}
		).subscribe(
			{
				next: (response) => {

					if (!response[0]) {
						this.initProductByDefaultValue();
					} else {
						this.product = response[0];
					}

					if (response[0].secondHeaderName != null) {
						this.SecondHeaderName = response[0].secondHeaderName;
					}
				}
			}
		);

		this.capacityService.getCapacityDeepDiveTreeListData(
			this.selectedProduct.esoObjectId,
			{
				showLoadingIndicator: true,
			}
			
		).subscribe(
			{
				next: (response) => {
				

					this.sourcingTreeListColumns = response.columns;
					this.sourcingTreeListColumns.concat(this._capacityCaptions);

					// Clear array and add selected object.
					this.sourcingTreeListData = [{ ProductId: this.selectedProduct.code, InputEsoObjectId: this.selectedProduct.esoObjectId }];

					for (let a = 0; a < response.data.length; a++) {
						const element = response.data[a];

						this.sourcingTreeListData.push(element);
					}

					for (let i = 0; i < this.sourcingTreeListData.length; i++) {
						this.capacityService
							.getCapacityInfoByProduct(this.sourcingTreeListData[i].ProductId)
							.subscribe(response => {
								this.sourcingTreeListData[i].capacityTable = response.data;
							});
					}
				}
			}
		);

		if (this.selectedProduct) {
			this.selectedProductCode = this.selectedProduct.code;
		}
	}

	private getProductsData(selectedProduct?: Data): void {
		this.esoService.getSlimDataFast().subscribe(
			{
				next: (response: any) => {
					const urlSelectedId = this.route.snapshot.queryParamMap.get("id");

					if (urlSelectedId) {
						const resultObject = response.find((x) => x.code === urlSelectedId);
						this.selectedProduct = resultObject;
					} else {
						this.selectedProduct = selectedProduct || response[0];
						if (selectedProduct == null || selectedProduct == undefined) {
							this.getCapacityTable(this.selectedProduct.code);
						}
					}

					this.getProductData();

					this.allProducts = response;
					this.product = response[0];

					this.selectedProductCode = this.selectedProduct.code;
				}
			}
		);
	}

	currcyFormat = function () {
		return UtilsService.CurrcyFormat(2);
	}
}
